import { api, unwrap } from './http';

const pendingRequestCalls = new Map();

const pendingRequestKey = (path, params = {}) => `${path}:${JSON.stringify(params || {})}`;

const getPendingTraceable = (path, params = {}) => {
  const key = pendingRequestKey(path, params);

  if (params && params.status === 'pending' && pendingRequestCalls.has(key)) {
    return pendingRequestCalls.get(key);
  }

  const request = unwrap(api.get(path, params))
    .finally(() => {
      pendingRequestCalls.delete(key);
    });

  if (params && params.status === 'pending') {
    pendingRequestCalls.set(key, request);
  }

  return request;
};

// Plan-subscription + class-booking approval queues (staff / FE web-admin surface).
export default {
  // Plan (membership) requests — paged: { data: [...], totalItemCount }
  listMembershipRequests: async (params = {}) => getPendingTraceable('/Memberships/Requests', params),
  acceptMembershipRequest: async (id, payload = {}) => unwrap(api.post(`/Memberships/Requests/${id}/Accept`, payload, {
    transformRequest: [(data) => (typeof data === 'string' ? data : JSON.stringify(data))],
  })),
  rejectMembershipRequest: async (id) => unwrap(api.post(`/Memberships/Requests/${id}/Reject`)),

  // Class-booking requests — plain list
  listClassRequests: async (params = {}) => getPendingTraceable('/Classes/Requests', params),
  acceptClassRequest: async (id) => unwrap(api.post(`/Classes/Requests/${id}/Accept`)),
  rejectClassRequest: async (id) => unwrap(api.post(`/Classes/Requests/${id}/Reject`)),
};
